import React, { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { usePermissions } from '../util/permissions'

const Tabs = styled.div`
  border-bottom: 1px solid var(--hairline, #eef1f5);
  display: flex;
  gap: 18px;
`

const Tab = styled.button<{ $active?: boolean }>`
  background: none;
  border: 0;
  border-bottom: 2px solid ${({ $active }) => $active ? 'var(--ink, #20242d)' : 'transparent'};
  color: ${({ $active }) => $active ? 'var(--ink, #20242d)' : 'var(--text-muted, #697386)'};
  cursor: pointer;
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: -1px;
  padding: 2px 2px 10px;
  transition: color 0.16s ease, border-color 0.16s ease;

  &:hover {
    color: var(--ink, #20242d);
  }

  &:focus-visible {
    border-radius: 6px;
    outline: 2px solid var(--ink, #20242d);
    outline-offset: 2px;
  }
`

/**
 * Catalog sub-navigation: discount codes live as a sibling tab of products
 * rather than their own nav entry.
 */
const CatalogTabs = ({ active }: { active: 'products' | 'discounts' }): ReactElement => {
  const navigate = useNavigate()
  const { has } = usePermissions()

  return <Tabs role='tablist' aria-label='Catalog'>
    <Tab
      type='button'
      role='tab'
      aria-selected={active === 'products'}
      $active={active === 'products'}
      onClick={() => active !== 'products' && navigate('/products')}>
      Products
    </Tab>
    {has('ReadDiscountCodes') && <Tab
      type='button'
      role='tab'
      aria-selected={active === 'discounts'}
      $active={active === 'discounts'}
      onClick={() => active !== 'discounts' && navigate('/discount_codes')}>
      Discount codes
    </Tab>}
  </Tabs>
}

export default CatalogTabs
